import { VariaveisAmbiente } from 'config';
import { ApiListModel } from 'model/api/gestao/api-list-model/api-list-model';
import { TerminalModel } from 'model/api/gestao/terminal/terminal-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetTerminal() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<ApiListModel<TerminalModel>>();

    const getTerminal = useCallback(
        (newPage: number, query?: string) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/terminal?page=${newPage}&${query}`,
                method: 'GET',
                enviarTokenUsuario: true,
                timeout: 15000,
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getTerminal,
    };
}
